import { Link } from "react-router-dom";
import { useProfileStore } from "../../store/useUserStore";
import { useTranslation } from "react-i18next";

const CourseCard = ({
  course_id,
  name,
  concatDayArray,
  images,
  pricing_packages,
  saveCourseAndNavigate,
  promotions_tag,
  navigateTo,
  explore,
  schedule,
}: {
  course_id: number;
  name: string;
  concatDayArray: string[];
  images?: string[];
  pricing_packages?: { id: number; fee: number; count: number }[];
  saveCourseAndNavigate?: (course_branch_id: number) => void;
  promotions_tag?: string[];
  navigateTo?: string;
  explore: boolean;
  schedule?: { pre_enroll: boolean }[];
}) => {
  const { setLastVisitedCourseId } = useProfileStore();
  const { t } = useTranslation();

  // Determine the navigation path
  const linkTo = navigateTo || `/course/${course_id}`;

  const handleClickToSave = (e: React.MouseEvent) => {
    setLastVisitedCourseId(course_id.toString());
    if (saveCourseAndNavigate) {
      e.preventDefault(); // prevent default <Link> behavior if handling manually
      saveCourseAndNavigate(course_id);
    }
  };

  const handleClickNoSave = () => {
    setLastVisitedCourseId(course_id.toString());
  };

  return (
    <div className="rounded-xl mb-8 shadow-course-card relative">
      <div className="absolute top-3 left-0 z-10 flex flex-col gap-1">
        {promotions_tag &&
          promotions_tag.length > 0 &&
          promotions_tag.map((tag, index) => {
            if (tag === "sibling") {
              return (
                <div
                  key={index}
                  className="bg-red-500 text-white px-3 py-1 text-xs font-semibold rounded-r-md shadow-md"
                >
                  {t("promotion.sibling")}
                </div>
              );
            }
            if (tag === "bundle") {
              return (
                <div
                  key={index}
                  className="bg-orange-400 text-white px-3 py-1 text-xs font-semibold rounded-r-md shadow-md"
                >
                  {t("promotion.bundle")}
                </div>
              );
            }
            if (tag === "promotion") {
              return (
                <div
                  key={index}
                  className="bg-blue-500 text-white px-3 py-1 text-xs font-semibold rounded-r-md shadow-md"
                >
                  {t("promotion.promotion")}
                </div>
              );
            }
            return null;
          })}
        {schedule && schedule.some((s) => s.pre_enroll) && (
          <div className="bg-[#023f81] text-white px-3 py-1 text-xs font-semibold rounded-r-md shadow-md">
            {t("course_view.pre_enrol")}
          </div>
        )}
      </div>

      <div className="text-center mb-1">
        <Link
          to={linkTo}
          onClick={
            saveCourseAndNavigate ? handleClickToSave : handleClickNoSave
          }
        >
          {images && images.length > 0 ? (
            <img
              style={{ height: "10rem" }}
              className="img-fluid rounded-tl-lg rounded-tr-lg inline-block"
              alt=""
              src={images[0]}
            />
          ) : (
            <img
              style={{ height: "10rem" }}
              className="img-fluid rounded-tl-lg rounded-tr-lg inline-block"
              alt=""
              src="/assets/img/products/product1.png"
            />
          )}
        </Link>
      </div>
      <div
        className={`px-2 pb-2 ${
          concatDayArray?.length > 1 ? "min-h-[4rem]" : ""
        }`}
      >
        <div className="flex justify-between items-start gap-2 min-h-[2.5em] pt-0.5">
          <div
            className="font-semibold text-base line-clamp-2 overflow-hidden text-ellipsis"
            title={name}
          >
            <Link
              to={linkTo}
              onClick={
                saveCourseAndNavigate ? handleClickToSave : handleClickNoSave
              }
            >
              {name}
            </Link>
          </div>
          {!explore && pricing_packages && pricing_packages.length > 0 && (
            <div className="text-[#00C39A] font-semibold text-base whitespace-nowrap">
              RM {pricing_packages[0].fee}
            </div>
          )}
        </div>
        <div className="flex flex-wrap gap-2 mt-2">
          {concatDayArray?.map((day: string, index: number) => (
            <div
              key={index}
              className="px-2 py-1 rounded-lg bg-[#F1F1F1] text-gray-500 text-xs font-medium"
            >
              {day}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
